import React from 'react';
import { Switch, Route } from 'react-router-dom';
// HOMEPAGE
import NewHomeDashboardPage from './NewHomeDashboardPage';

// INDUSTRY UPDATES
import IndustryUpdates from './industry/IndustryUpdates';

// HELP CENTER
import FAQ from './training/FAQ';

// DATA MODULES
import DataPage from './data/DataPage';
import DataSetViewPage from 'pages/data/DataSetViewPage';
import Watchlist from 'pages/watchlist/Watchlist';
import BiteList from 'pages/bite-list/BiteList';
import TradeProtection from 'pages/trade-protection/TradeProtection';
import CyberProtection from 'pages/cyber-protection/CyberProtection';
import BiteScore from 'pages/bite-score/BiteScore';
import BiteBulk from 'pages/bite-bulk/BiteBulk';

// SCREENING MODULES
import Screening from './screening/Screening';
import BiteAI from 'pages/bite-ai/BiteAI';
import Classification from 'pages/classify/Classification';
import TariffChecker from 'pages/tariffs/TariffChecker';
import BiteAIStream from 'pages/bite-ai/BiteAIStream';
import BiteViz from 'pages/bite-viz/BiteViz';
import BiteAPI from './bite-api/BiteAPI';

// Monitor
import Case from 'pages/cases/Case';
import VaultHome from './cases/VaultHome';
import Monitor from './monitor/Monitor';
import Ticket from './monitor/Ticket';
import CreateTicket from './automations/AutomationBuilder';
import SubmitQuestionnaire from './automations/SubmitQuestionnaire';

// ACCOUNT
import JoinTeamFromInvite from 'pages/teams/JoinTeamFromInvite';
import SuperAdminDashboard from 'pages/superAdmin/SuperAdminDashboard';
import TeamAccess from 'pages/superAdmin/TeamAccess';
import ManualTeamSetup from 'pages/superAdmin/ManualTeamSetup';
import TeamSelectView from 'pages/superAdmin/TeamSelectView';
import ProfileHome from 'pages/profile/ProfileHome';
import ServiceAccountCreate from './teams/ServiceAccountCreate';
import ServiceAccountAccess from 'pages/superAdmin/ServiceAccountAccess';

// BITE U
import ResourcesHome from 'pages/training/ResourcesHome';
import BITEUCourseInfo from './training/BITEUCourseInfo';
import BITEUCoursePage from './training/BITEUCoursePage';
import DevDocs from 'pages/training/DevDocs';

// TRAINING VIDEOS
import TrainingVideos from 'components/Training/videos/TrainingVideos';
import LicensesVideo from 'components/Training/videos/LicensesVideo';
import ModuleVideo from 'components/Training/videos/ModuleVideo';
import PaymentsVideo from 'components/Training/videos/PaymentsVideo';
import QuickStartVideo from 'components/Training/videos/QuickStartVideo';
import VaultVideo from 'components/Training/videos/VaultVideo';
import ScreenVideo from 'components/Training/videos/ScreenVideo';
import ModulesVideo from 'components/Training/videos/ModulesVideo';
import BulkVideo from 'components/Training/videos/BulkVideo';
import GPTVideo from 'components/Training/videos/GPTVideo';
import BITEUVideo from 'components/Training/videos/BiteUVideo';

const Routes: React.FC = () => {
  return (
    <Switch>
      {/* HOMEPAGE */}
      <Route exact path='/' component={NewHomeDashboardPage} />

      {/* INDUSTRY UPDATES */}
      <Route path='/industry-updates' component={IndustryUpdates} />

      {/* HELP CENTER */}
      <Route path='/faq' component={FAQ} />

      {/* DATA MODULES */}
      <Route path='/data' component={DataPage} />
      <Route path='/data-view' component={DataSetViewPage} />
      <Route path='/watchlist' component={Watchlist} />
      <Route path='/bite-list' component={BiteList} />
      <Route path='/bite-score' component={BiteScore} />
      <Route path='/bite-bulk' component={BiteBulk} />
      <Route path='/bite-trade-protection' component={TradeProtection} />
      <Route path='/bite-cyber-protection' component={CyberProtection} />

      {/* SCREENING MODULES */}
      <Route path='/screening' component={Screening} />
      <Route path='/bite-ai-legacy' component={BiteAI} />
      <Route path='/bite-ai' component={BiteAIStream} />
      <Route path='/bite-viz' component={BiteViz} />
      <Route path='/bite-api' component={BiteAPI} />

      {/* Classify */}
      <Route path='/bite-classify' component={Classification} />

      {/* Tariff */}
      <Route path='/tariff-checker' component={TariffChecker} />


      {/* ACCOUNT */}
      <Route path='/profile' component={ProfileHome} />
      <Route path='/super-admin-dashboard' component={SuperAdminDashboard} />
      <Route path='/team-access' component={TeamAccess} />
      <Route path='/service-account-access' component={ServiceAccountAccess} />
      <Route path='/team/:id' component={TeamSelectView} />
      <Route path='/manual-team-setup' component={ManualTeamSetup} />
      <Route path='/join-team/:id' component={JoinTeamFromInvite} />
      <Route path='/service-account' component={ServiceAccountCreate} />

      {/* MONITOR */}
      <Route path='/analytics-vault/case/:case_id' component={Case} />
      <Route path='/analytics-vault/case' component={Case} />
      <Route path='/analytics-vault' component={VaultHome} />
      <Route path='/monitor/ticket/:ticket_id' component={Ticket} />
      <Route path='/bite-monitor' component={Monitor} />
      <Route path='/create-ticket' component={CreateTicket} />
      <Route path='/submit-questionnaire/:ticket_id' component={SubmitQuestionnaire} />


      {/* BITE U */}
      <Route path='/resources' component={ResourcesHome} />
      <Route path='/bite-u/course-info' component={BITEUCourseInfo} />
      <Route path='/bite-u/course-training' component={BITEUCoursePage} />
      <Route path='/developer-docs' component={DevDocs} />

      {/* TRAINING VIDEOS */}
      <Route path='/training-videos' component={TrainingVideos} />
      <Route path='/screening-video' component={ScreenVideo} />
      <Route path='/data-modules-video' component={ModulesVideo} />
      <Route path='/licenses-video' component={LicensesVideo} />
      <Route path='/module-quick-start-video' component={ModuleVideo} />
      <Route path='/payments-video' component={PaymentsVideo} />
      <Route path='/quick-start-video' component={QuickStartVideo} />
      <Route path='/analytics-vault-video' component={VaultVideo} />
      <Route path='/bite-bulk-video' component={BulkVideo} />
      <Route path='/bite-u-video' component={BITEUVideo} />
      <Route path='/bite-gpt-video' component={GPTVideo} />

    </Switch>
  );
};

export default Routes;
